import { Food, JournalEatableContainerObject } from 'Models'
import { Calculator } from 'Utils'

const calculateVegetableAndFruitIntake = (
  flattenedJournalEatableRecordsContainers: JournalEatableContainerObject[]
): { vegetableIntake: number; fruitIntake: number } => {
  let totalVegetableIntake = 0
  let totalFruitIntake = 0

  const addNutritionIntake = (food: Food | undefined, grams: number, portionRatio = 1) => {
    if (!food) return

    const adjustedGrams = grams * portionRatio

    if (food.vegetable && food.vegetable > 0) {
      totalVegetableIntake += (food.vegetable / 100) * adjustedGrams
    }

    if (food.fruit && food.fruit > 0) {
      totalFruitIntake += (food.fruit / 100) * adjustedGrams
    }
  }

  flattenedJournalEatableRecordsContainers.forEach((container) => {
    container.eatableCardObjects.forEach((cardObject) => {
      const eatable = cardObject.eatable

      if (eatable.food) {
        const grams = Calculator.calculateEatableWeight(eatable)?.quantity || 0
        addNutritionIntake(eatable.food, grams)
      }

      if (eatable.recipe) {
        const recipe = eatable.recipe
        const eatableQuantity = eatable.quantity || 0
        const portionRatio =
          eatable.unit === 'GRAM'
            ? eatableQuantity / (recipe.portionAmount * recipe.defaultServingsCount)
            : eatableQuantity / recipe.defaultServingsCount

        recipe.ingredients?.forEach((ingredient) => {
          const ingredientGrams = Calculator.calculateEatableWeight(ingredient)?.quantity || 0
          addNutritionIntake(ingredient.food, ingredientGrams, portionRatio)
        })
      }
    })
  })

  return {
    vegetableIntake: Math.round(totalVegetableIntake),
    fruitIntake: Math.round(totalFruitIntake)
  }
}

export default calculateVegetableAndFruitIntake
